import React from 'react';
export function HeroImage() {
  return <section className="w-full" data-id="element-8">
      <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1772481006/hf_20260302_151338_fff75a9b-7599-4edf-94bb-865c0632c437_hbhws0.jpg" alt="Biohacking y Alimentación Consciente" className="w-full block" data-id="element-9" />
    </section>;
}